import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import ChargerModule from '../../components/chargerModule';
import { countriesList, createCountry, getAvailableCountries, updateCountryData } from '../../services/countriesList';
import { ICountryDetail, INewCountryForm, IUpdateCountry } from '../../types/countries';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { CountryCard, HeaderCountryList, AddCountry, NewCountry, LoaderCard } from './components';
import { TAny } from '../../types/blog';
import { createNewProvider } from '../../services/orders';
import './countriesList.scss';

const CountriesList = () => {
  const list = Array(5).fill('.');
  const headerInfo = {
    title: 'Países',
    subtitle: '',
    headerNote: '*Todos los países creados quedan como opción para gestión de empleados y herramientas.'
  };
  const infoSideBar = { position: 'country' };
  const [openAddCountry, setOpenAddCountry] = useState<boolean>(false);
  const [countries, setCountries] = useState<ICountryDetail[]>([]);
  const [preCountry, setPreCountry] = useState<INewCountryForm>();
  const [newCountry, setNewCountry] = useState<ICountryDetail>();
  const [loadingUpdateCountry, setLoadingUpdateCountry] = useState<number>(0);
  const [addLoading, setAddLoading] = useState<boolean>(false);
  const [generalLoading, setGeneralLoading] = useState<boolean>(false);
  const [availableList, setAvailableList] = useState<TAny>();
  const getDataList = async (generalLoading?: boolean) => {
    if (generalLoading) {
      setGeneralLoading(true);
    }
    try {
      const data = await countriesList();
      if (data && data.length > 0) {
        setCountries(data);
      }
      setGeneralLoading(false);
      setPreCountry(undefined);
      setNewCountry(undefined);
    } catch (error) {
      displayErrorNotification();
      setGeneralLoading(false);
    }
  };

  const handleupdateCountry = async (data: IUpdateCountry, countryId: number) => {
    setLoadingUpdateCountry(countryId);
    try {
      await updateCountryData(data, countryId);
      await getDataList();
      setLoadingUpdateCountry(0);
      displaySuccessNotification({ customJSXMessage: <>Se guardó la información correctamente.</> });
    } catch (error) {
      displayErrorNotification();
      setLoadingUpdateCountry(0);
    }
  };

  const handleAddNewCountry = async (data: IUpdateCountry) => {
    setAddLoading(true);
    const addBody = {
      code: preCountry?.ISOCode,
      currency: preCountry?.currencyType?.toLocaleUpperCase(),
      exchangeRate: data.exchangeRate,
      taxRate: data.taxRate,
      phoneCode: data.phoneCode,
      documentType: preCountry?.documentName?.toLocaleUpperCase(),
      documentExample: data.documentExample,
      registry: data.registry,
      buy: data.buy,
      logisticService: data.logisticService,
      storage: data?.storage
    };
    var formData = new FormData();
    const extension = preCountry?.flag.name.substring(preCountry?.flag.name.lastIndexOf('.')).toLowerCase();
    preCountry?.flag && formData.append('file', preCountry.flag, `country-img-${uuid()}.${extension}`);
    formData.append('data', JSON.stringify(addBody));
    try {
      await createCountry(formData);
      await getDataList();
      setAddLoading(false);
      displaySuccessNotification({ customJSXMessage: <>El país quedo creado, termina de llenar la información para activarlo.</> });
    } catch (error) {
      setAddLoading(false);
      displayErrorNotification();
    }
  };

  const handleNewProvider = async (provider: string, countryCode: string, countryId: number) => {
    setLoadingUpdateCountry(countryId);
    try {
      const body = {
        name: provider,
        countryId,
        countryCode
      };
      await createNewProvider(body);
      await getDataList();
      displaySuccessNotification({ customJSXMessage: <>Se guardó la información correctamente.</> });
      setLoadingUpdateCountry(0);
    } catch (error) {
      displayErrorNotification();
      setLoadingUpdateCountry(0);
    }
  };

  const formatNewCuntry = (data: INewCountryForm) => {
    const base64File: string = URL.createObjectURL(data.flag);
    setNewCountry({
      documentType: data.documentName,
      currencyCode: data.currencyType,
      flag: base64File,
      code: data.ISOCode
    });
    setOpenAddCountry(false);
    window.location.href = '#startPage';
  };

  const handleNewCountry = (data: INewCountryForm) => {
    formatNewCuntry(data);
    setPreCountry(data);
  };

  const getListAvailableCountries = async () => {
    try {
      const data = await getAvailableCountries();
      setAvailableList(data);
    } catch (error) {
      displayErrorNotification();
    }
  };

  useEffect(() => {
    getDataList(true);
    getListAvailableCountries();
  }, []);

  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={infoSideBar}>
      <div id="countriesList">
        <div className="boxCountriesList">
          <HeaderCountryList />
          <div className="containerCountryItems">
            <div id="startPage" />
            {newCountry && (
              <>
                {addLoading ? (
                  <LoaderCard />
                ) : (
                  <CountryCard
                    addLoading={addLoading}
                    countryData={newCountry}
                    handleAddNewCountry={handleAddNewCountry}
                  />
                )}
              </>
            )}
            {generalLoading &&
              list &&
              list.map(() => {
                return <LoaderCard key={uuid()} />;
              })}
            {countries &&
              countries.length > 0 &&
              countries.map(item => {
                return (
                  <CountryCard
                    updateLoading={loadingUpdateCountry}
                    key={item.id}
                    countryData={item}
                    handleupdateCountry={(data, countryId) => {
                      handleupdateCountry(data, countryId);
                    }}
                    handleNewProvider={handleNewProvider}
                  />
                );
              })}
            {openAddCountry && availableList && countries ? (
              <NewCountry
                registerList={countries}
                availableList={availableList}
                className="mt-16"
                handleNewCountry={handleNewCountry}
                closeNewCountry={() => {
                  setOpenAddCountry(false);
                }}
              />
            ) : (
              <AddCountry
                disabled={!!newCountry || generalLoading}
                className="mt-16"
                action={() => {
                  setOpenAddCountry(true);
                }}
              />
            )}
            <div className="h-64 w-full" />
          </div>
        </div>
      </div>
    </ChargerModule>
  );
};
export default CountriesList;
